import { Box, Link as ExternalLink, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import BoatAndBuoyAtSea from "../assets/svg/BoatAndBuoyAtSea";
import { BACKGROUND_COLOR } from "../styles/Theme";

function Copyright() {
	return (
		<Typography variant="body2" color="text.secondary" align="center">
			{"Copyright © "}
			<ExternalLink color="inherit" href="https://smartocean.com/">
				Smart Ocean AS
			</ExternalLink>{" "}
			{new Date().getFullYear()}.
		</Typography>
	);
}

const FooterLink = styled(Link)`
	text-decoration: none;
	font-weight: ${(props) => props.theme.typography.fontWeightBold};
	color: ${(props) => props.theme.palette.common.black};

	&:hover {
		text-decoration: underline;
	}
`;

function Footer() {
	const { t } = useTranslation();
	return (
		<Box component="footer" sx={{ p: 2, bgcolor: BACKGROUND_COLOR, width: "100%", mb: 8 }}>
			<BoatAndBuoyAtSea showBuoy={true} />
			<Box
				sx={{
					maxWidth: "md",
					display: "flex",
					justifyContent: "space-evenly",
					mb: 4,
					mx: "auto",
					mt: 1
				}}
			>
				<Typography variant="body2" color="text.secondary" component={FooterLink} to="/sales-conditions">
					{t("footer.salesConditions")}
				</Typography>
				<Typography variant="body2" color="text.secondary" component={FooterLink} to="/privacy-policy">
					{t("footer.privacyPolicy")}
				</Typography>
			</Box>
			<Copyright />
		</Box>
	);
}

export default Footer;
